import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const GalleryModal = () => {
  const [selected, setSelected] = useState(0);
  const [lightbox, setLightbox] = useState(false);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* GALLERY MODALS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Gallery Modals</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Grid Gallery</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="grid grid-cols-3 gap-2">
                {[1,2,3,4,5,6].map(i => <div key={i} className="aspect-square bg-gradient-to-br from-slate-700 to-slate-800 rounded cursor-pointer hover:border border-amber-400"></div>)}
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="grid grid-cols-3 gap-2">
  {images.map((img, i) => (
    <img key={i} src={img} className="w-full aspect-square rounded cursor-pointer" onClick={() => setSelected(i)} />
  ))}
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Lightbox Modal</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-slate-800 h-20 rounded mb-2 cursor-pointer flex items-center justify-center" onClick={() => setLightbox(true)}><span className="text-slate-400 text-sm">Click to Open</span></div>
              {lightbox && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center" onClick={() => setLightbox(false)}><div className="relative max-w-2xl w-full" onClick={e => e.stopPropagation()}><div className="bg-slate-800 h-64 rounded flex items-center justify-center"><span className="text-slate-400">Image Preview</span></div><button className="absolute top-2 right-2 text-white text-2xl bg-black/50 w-8 h-8 rounded">?</button></div></div>}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`const [open, setOpen] = useState(false);

return (
  <>
    <img onClick={() => setOpen(true)} />
    {open && (
      <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center" onClick={() => setOpen(false)}>
        <img src={full_size} className="max-w-2xl" />
      </div>
    )}
  </>
);`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Carousel Gallery</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-gradient-to-br from-amber-600 to-amber-600 h-20 rounded mb-2"></div>
              <div className="flex gap-1 justify-center">{[1,2,3,4,5].map(i => <div key={i} className={`w-2 h-2 rounded-full ${i === selected ? "bg-amber-400" : "bg-slate-600"}`}></div>)}</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`const [idx, setIdx] = useState(0);

return (
  <div>
    <img src={images[idx]} />
    <div className="flex gap-1 justify-center">
      {images.map((_, i) => (
        <button key={i} onClick={() => setIdx(i)} className={i === idx ? "bg-amber-400" : "bg-slate-600"} />
      ))}
    </div>
  </div>
);`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Folder Structure</label>
            <div className="p-2 bg-slate-950 rounded border border-slate-600 text-xs space-y-1">
              <div className="text-slate-400">?? Gallery</div>
              <div className="pl-3 space-y-1">
                <div className="text-slate-400">??? Image 1</div>
                <div className="text-slate-400">??? Image 2</div>
                <div className="text-slate-400">??? Image 3 (viewing)</div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-3 bg-slate-800 rounded text-sm">
  <p className="text-slate-400">?? Gallery</p>
  <div className="pl-3">
    {items.map(item => (
      <p key={item} className="text-slate-400">??? {item}</p>
    ))}
  </div>
</div>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED GALLERIES */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Galleries</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Masonry Layout</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="columns-3 gap-2 space-y-2">
                <div className="bg-slate-700 h-16 rounded"></div>
                <div className="bg-slate-700 h-20 rounded"></div>
                <div className="bg-slate-700 h-16 rounded"></div>
                <div className="bg-slate-700 h-20 rounded"></div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="columns-3 gap-2">
  {images.map(img => (
    <img key={img} src={img} className="w-full rounded mb-2" />
  ))}
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Infinite Scroll</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600 h-32 overflow-y-auto space-y-1">
              {[1,2,3,4,5,6].map(i => <div key={i} className="flex gap-2"><div className="w-12 h-12 bg-slate-700 rounded flex-shrink-0"></div><div className="text-xs text-slate-400">Photo {i}</div></div>)}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`useEffect(() => {
  const handleScroll = () => {
    if (scrollPos + height >= totalHeight) {
      loadMore();
    }
  };
  window.addEventListener('scroll', handleScroll);
}, []);`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryModal;


